export function supportsColor(jsonMode: boolean): boolean {
  return (
    process.stdout.isTTY === true &&
    process.env.NO_COLOR === undefined &&
    !jsonMode
  );
}
